<template>
    <div>
        <div class="sidebar" data-theme="light">
             <el-tooltip class="item" effect="light" hide-after="100000" placement="left-start" >
                <div slot="content" >
                    <img style="width: 180px;" src="../../../static/image/app.png" />
                </div>
                <div class="qrcodeBox sidebarList">
                    <div class="qrCodeBtn" style="text-align: center;">
                        <img style="width: 30px;z-index: 99;position: relative;"
                                    src="../../../static/image/qr.png">
                    </div>
                    <div class="sidebarText">扫码下载</div>
                </div>
             </el-tooltip>

              <el-tooltip style="margin-top: 20px;" class="item" effect="light" hide-after="100000" placement="left-start" >
                <div slot="content" >
                    <img style="width: 180px;" :src="kefuList[0].qrUrl" />
                </div>
                <div class="qrcodeBox sidebarList">
                    <div class="qrCodeBtn" style="text-align: center;">
                        <img style="width: 30px;z-index: 99;position: relative;"
                                    src="../../../static/image/qr.png">
                    </div>
                    <div class="sidebarText">在线客服</div>
                </div>
             </el-tooltip>
            

        </div>
    </div>
</template>

<script>

import {
    sendPostRqe
} from '@/api/api.js';

export default {
    name: "Banner",
    data() {
        return {
             kefuList:[{qrUrl:''}],   
        }
    },
    mounted() {
        this.getKefuList()
    },
    methods: {
        getKefuList() {
             sendPostRqe({},'/kfQrInfo/list').then(res => {
                console.log(res)
                this.kefuList = res.data
            })

        }
    }
}
</script>

<style scoped>
  
.sidebar{
    position: fixed;
    right: 10px;
    bottom: 200px;
    padding: 15px 8px;
    z-index: 10;
    background: #fff;
    border-radius: 15px;
    border: 1px solid #EDEFF2;
}

.sidebarText {
    margin-top: 4px;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    -webkit-transition: all .2s;
    transition: all .2s;
    color: #737780;
}


</style>
